import { apiClient } from '~/api';
import { textContentPopulations } from '~/populations/base';
import type { Footer } from '~/types/footer';
import type { Strapi5ResponseSingle } from '@nuxtjs/strapi';

export default async function getFooter(locale: string) {
  const params = {
    locale,
    populate: {
      categoriesColumns: {
        populate: {
          categories: {
            populate: {
              items: true,
            },
          },
        },
      },
      topLinks: {
        populate: {
          title: true,
        },
      },
      helpDesk: {
        populate: {
          title: true,
        },
      },
      socials: {
        populate: {
          icon: true,
        },
      },
      bottomLinks: true,
      mobileAppSection: {
        populate: {
          desktopText: textContentPopulations,
          qrCodeImage: true,
        },
      },
    },
  };

  const { data } = await apiClient<Strapi5ResponseSingle<Footer>>('/footer', {
    cacheKey: getApiRequestCacheKey('footer', { locale }),
    params,
  });

  return data;
}
